import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  GetBuildingsMetrics_cityTaskMetrics_buildingMetrics as BuildingMetricsGenerated,
  GetBuildingsMetrics as GetBuildingsMetricsGenerated,
  GetBuildingsMetricsVariables as GetBuildingsMetricsVariablesGenerated,
  GetBuildingsMetrics_cityTaskMetrics_buildingMetrics_metricHeaders as MetricHeadersGenerated,
  GetBuildingsMetrics_cityTaskMetrics_buildingMetrics_metricRows as MetricRowsGenerated,
  GetBuildingsMetrics_cityTaskMetrics_buildingMetrics_metricRows_metrics as MetricsGenerated,
} from "core/queries/__generated__/GetBuildingsMetrics";

export interface BuildingMetricsData extends BuildingMetricsGenerated {}
export interface GetBuildingsMetricsResponse
  extends GetBuildingsMetricsGenerated {}
export interface GetBuildingsMetricsVariables
  extends GetBuildingsMetricsVariablesGenerated {}
export interface MetricData extends MetricsGenerated {}
export interface MetricHeadersData extends MetricHeadersGenerated {}
export interface MetricRowData extends MetricRowsGenerated {}

const getBuildingsMetrics = gql`
  query GetBuildingsMetrics($filter: TaskMetricsFilterInput!) {
    cityTaskMetrics {
      buildingMetrics(filters: $filter) {
        metricHeaders {
          label
          tooltip
        }
        metricRows {
          metrics {
            formattedValue
            value
          }
          resource {
            id
            imageUrl
            name
          }
        }
      }
    }
  }
`;

export interface UseGetBuildingsMetricsOptions {
  skip: boolean;
  variables: GetBuildingsMetricsVariables;
}

export const useGetBuildingsMetricsQuery = ({
  skip = false,
  variables,
}: UseGetBuildingsMetricsOptions) =>
  useQuery<GetBuildingsMetricsResponse, GetBuildingsMetricsVariables>(
    getBuildingsMetrics,
    {
      skip,
      variables,
    },
  );
